import { useSyncExternalStore } from 'react';

/**
 * Preferencias de los controles táctiles (celular), guardadas en el navegador:
 * tamaño de los botones y lado del botón de acción (zurdos: a la izquierda,
 * con el joystick a la derecha).
 */
export interface TouchPrefs {
  size: 'normal' | 'grande';
  actionSide: 'right' | 'left';
}

const KEY = 'sportsarena.touch';
const DEFAULTS: TouchPrefs = { size: 'normal', actionSide: 'right' };

const read = (): TouchPrefs => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? 'null') as Partial<TouchPrefs> | null;
    return {
      size: raw?.size === 'grande' ? 'grande' : 'normal',
      actionSide: raw?.actionSide === 'left' ? 'left' : 'right',
    };
  } catch {
    return DEFAULTS;
  }
};

let prefs: TouchPrefs = typeof window === 'undefined' ? DEFAULTS : read();
const listeners = new Set<() => void>();

export const getTouchPrefs = (): TouchPrefs => prefs;
export const setTouchPrefs = (patch: Partial<TouchPrefs>): void => {
  prefs = { ...prefs, ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    /* sin almacenamiento */
  }
  listeners.forEach((l) => l());
};

export const useTouchPrefs = (): TouchPrefs =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getTouchPrefs,
    getTouchPrefs
  );
